var map = {
	"./LP360-cloud-icon.svg": 93439,
	"./admin.svg": 47881,
	"./corporate.svg": 54663,
	"./icon-account-logout.svg": 10610,
	"./icon-cloud.svg": 97789,
	"./icon-token.svg": 65236,
	"./tour-guide.svg": 34135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63663;